import React from 'react';
import { intervalToDuration } from 'date-fns';
import { parseToDate } from '../../../../utils/date';

type Props = {
    expiresAt?: string | null;
    children?: React.ReactNode;
};

export type ExpiringAlertChildProps = {
    days: number;
    hours: number;
    show: boolean;
    expiresAt?: string;
};

const ExpiringAlert: React.FC<Props> = ({ expiresAt, children }) => {
    const now = new Date();

    if (!expiresAt) {
        return React.cloneElement(children as React.ReactElement, {
            days: 0,
            hours: 0,
            show: false
        });
    }

    const referenceDate = parseToDate(expiresAt);

    const { hours, days: daysDiffInterval } = intervalToDuration({
        start: now,
        end: referenceDate
    });

    const daysDiff =
        daysDiffInterval !== undefined && Number.isInteger(daysDiffInterval)
            ? Math.abs(daysDiffInterval)
            : undefined;

    const days = daysDiff ? daysDiff : 0;

    const limit = 10;

    return React.cloneElement(children as React.ReactElement, {
        days,
        hours,
        show: daysDiff && daysDiff <= limit,
        expiresAt
    });
};

export default ExpiringAlert;
